import {GridWidgetDataField} from './grid-widget-data-field';
import {GridWidgetFilter} from './grid-widget-filter';
import {DateFilter} from './date-filter';
import { pdsI18n } from '../../../src/pds-i18n';

export class DateField extends GridWidgetDataField {

  validationRules: DateFieldValidationRules;

  constructor(name: string, objectLookup: string | ((Object) => any), title: string, sortOrder?: any) {
    super(name, objectLookup, title, sortOrder);
  }

  getFilterInstance(): GridWidgetFilter {
    return new DateFilter(this);
  }

  setValidationRules(rules: DateFieldValidationRules): void {
    this.validationRules = rules;
  }

  resolveAsString(dataRow: any): string {
    let date: Date | undefined = this.resolve(dataRow);
    if (date != null) {
      return pdsI18n.formatDate(date, 'DATE');
    } else {
      return '';
    }
  }
}

export type DateFieldValidationRules = {
  'data-customvalidate'?: string
  //Max and min value left out on purpose because of the conflict with min and max when in the "range" mode.
  //Note: If anyone ever needs this we can figure out how to make it work.
};
